const VideoReviewTypes = ["team", "umpire"];

export const VideoReviewTypeSelect = {
  name: "video-review-types",
  component: "MainPanel",
  layout: "main-panel",
  mode: "visible",
  text: "videoReview.type",
  showOn: [
    { state: "secondary", value: "video-review-type-select", operator: "is" },
  ],
  startEvent: false,
  startPlay: false,
  allowFlag: true,
  allowCancel: true,
  children: [
    {
      name: "video-review-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        valueType: "boolean",
        children: VideoReviewTypes,
        layout: "type-button",
      },
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "circleEntry", type: "to" },
            {
              action: "nextState",
              value: "video-review-team-select",
              type: "secondary",
            },
          ],
          conditions: [
            {
              item: "options",
              value: "team",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            { action: "copyEvent", value: "circleEntry", type: "to" },
            { action: "clearData", value: ["entityId"], type: "main" },
            { action: "saveData", value: "videoReview", type: "eventType" },
            {
              action: "nextState",
              value: "video-review-outcome",
              type: "secondary",
            },
          ],
          conditions: [
            {
              item: "options",
              value: "umpire",
              event: "main",
              operator: "is",
            },
          ],
        },
      ],
    },
  ],
};
